<template>
  <div class="loose-view">
    <div class="course-arr">
      <div class="course-item" v-for="(item, index) in list" :key="index">
        <img :src="item.directory_img" alt="">
        <div>
          <h3>{{item.directory_name}}</h3>
          <span>授课老师：{{item.teacher_name}}</span>
          <span>学时：{{ item.file_period }}</span>
          <template v-if="item.is_choose == 0">
            <div v-if="!item.is_select" @click="cut_select(item, index)">添加</div>
            <div :class="item.is_required == 1 ? 'btn disabled' : 'btn'" v-if="item.is_select" @click="cut_select(item, index)">{{item.is_required == 1 ? '已选' : '取消'}}</div>
          </template>
          <div :class="item.is_choose == 1 ? 'btn disabled' : 'btn'" v-else>已选</div>
        </div>
      </div>
    </div>
  
    <div class="footer-place"></div>
  
    <div class="bottom-handle-pay">
      <div class="bottom-tips" style="font-weight: bold">
        <template v-if="total_period && total_period != 60">
          您已购<span class="num">{{total_period}}</span>学时,
        </template>
        请选所需学时交费
      </div>
  
      <div class="bottom-tips">
        已选<span class="num">{{ directory_ids.length }}</span>门
      </div>
      <div class="bottom-tips">
        共<span class="num">{{file_period}}</span>学时
      </div>
      
      <div class="total-price">
        共计：¥<span class="price">{{ sum_price }}</span
        >元（3元/学时）
      </div>
      <div class="pay-btn"  @click="handlePay">立即支付</div>
    </div>

    
    <el-dialog
      title="支付方式"
      width="330px"
      top="30vh"
      :visible.sync="wayVisible"
      :center="true">
      <div class="pay_way">
        <div @click="pay_radio = 2">
          <img src="../../../assets/weixin2.png" alt="">
          <span>微信</span>
          <div :class="{checke: pay_radio == 2}"></div>
          </div>
          <div @click="pay_radio = 1">
          <img src="../../../assets/balance.png" alt="">
          <span>账号余额</span>
          <div :class="{checke: pay_radio == 1}"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wayVisible = false;buy(pay_radio)">立即支付</el-button>
      </span>
    </el-dialog>
  
    <el-dialog
      :visible.sync="impVisible"
      top="30vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <span slot="title" style="font-weight: bold;font-size: 20px;color: red;">
        选课提示
      </span>
      <div
         class="hint-text"
      >
      根据国家药监局和人社部2024年发布的《执业药师继续教育暂行规定》，选择您需要的<span class="hint-zd">学时</span>。
      </div>
      <div
         class="hint-text"
      >
      1、如果您今年<span class="hint-zd">未获取</span>其他继续教育方式的学时，请至少<span class="hint-zd">选择60学时</span>的课程交费、学习。
      </div>
      <div
         class="hint-text"
      >
      2、如果您今年<span class="hint-zd">已获取</span>其他继续教育方式的学时，请<span class="hint-zd">按所需学时</span>选课、交费、学习。
      </div>
      <p style="text-align: center;cursor: pointer;color: blue;text-decoration: underline;" @click="bzVisible = true">《执业药师继续教育暂行规定》学时计算标准</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="impVisible = false">知道了</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      :visible.sync="bzVisible"
      top="15vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div style="max-height: 500px;overflow-y: auto;" class="jsbz">
        <h3 style="margin-bottom: 20px;font-size: 20px;">《执业药师继续教育暂行规定》学时计算标准如下：</h3>
        <div class="hint-text" style="font-size: 18px;">（一）参加省级以上药品监管部门、人力资源社会保障部门以及执业药师继续教育机构组织的脱产培训，每天最多按8学时计算。</div>
        <div class="hint-text" style="font-size: 18px;">（二）参加省级以上药品监管部门、人力资源社会保障部门以及执业药师继续教育机构组织的网络培训，按实际学时计算。</div>
        <div class="hint-text" style="font-size: 18px;">（三）参加国家教育行政主管部门承认的药学类、中药学类以及相关专业大学专科以上学历（学位）教育，获得学历（学位）当年度最多折算为90学时。</div>
        <div class="hint-text" style="font-size: 18px;">（四）独立承担药品监管部门、人力资源社会保障部门或者相关行业协会学会的执业药师类研究课题，或者独立承担相关科研基金项目，课题项目结项的，当年度每项最多折算为40学时；与他人合作完成的，主持人每项最多折算为30学时，参与人每人每项最多折算为10学时。</div>
        <div class="hint-text" style="font-size: 18px;">（五）独立公开发表执业药师类学术论文，每篇最多折算为10学时；与他人合作发表的，每人每篇折算最多为5学时。每人每年最多折算为60学时。</div>
        <div class="hint-text" style="font-size: 18px;">（六）独立公开出版执业药师类学术著作、译著等，每本最多折算为30学时；与他人合作出版的，第一作者每本最多折算为20学时，其他作者每人每本最多折算为10学时。每人每年最多折算为60学时。</div>
        <div class="hint-text" style="font-size: 18px;">（七）担任药品监管部门、人力资源社会保障部门或者相关行业协会学会组织举办的与执业药师工作相关的宣讲、巡讲，以及培训班、学术会议、专题讲座等活动授课（报告）人，最多按实际授课（报告）时间的6倍计算学时。</div>
        <div class="hint-text" style="font-size: 18px;">（八）参加药品监管部门、人力资源社会保障部门或者相关行业协会学会组织的与执业药师工作相关的评比、竞赛类活动等，获得三等奖或者相当等次以上，当年度每项最多折算为30学时，同一活动不累计计算。</div>
      </div>
    </el-dialog>
  
    
    <el-dialog
      :visible.sync="auditVisible"
      top="20vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span slot="title" style="font-weight: bold;font-size: 20px;color: red;">
        您是否已获其他继续教育方式学时？
      </span>
      <div class="jyfs-dialog">
        <p><span>没有</span>：请选择课程，达到60学时即可支付。</p>
        <p><span>有</span>：请<span class="hint-zd">加微信</span>联系老师，帮您向省药监局<span class="hint-zd">提交审核后</span>，<span class="hint-zd">再选课交费</span>，以防少选学时。</p>
        <div>
          <img src="@/assets/teacher_wx.png" alt=""/>
        </div>
        <div><span class="hint-zd">客服电话：400-811-5865转1</span></div>
      </div>
      <span slot="footer" class="dialog-footer" style="margin: 0 auto;display: block;width: fit-content;">
        <el-button type="primary" @click="auditVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  
    <el-dialog
      :visible.sync="auditVisible2"
      top="20vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <span slot="title" style="font-weight: bold;font-size: 20px;color: red;">
        选课提示
      </span>
      <div class="jyfs-dialog">
        <nav>您今年是否已参加其他继续教育方式学习并获得相应学时？</nav>
        <header>
          <el-button plain @click="auditVisible2 = false">取消</el-button>
          <el-button type="primary" @click="auditVisible2 = false;uploadVisible = true">确定</el-button>
        </header>
        <div><span class="hint-zd">专属老师微信：</span></div>
        <div>
          <img src="@/assets/teacher_wx.png" alt=""/>
        </div>
        <div>服务时间：周一至周五8:30-17:30</div>
        <div><span class="hint-zd">客服电话：400-811-5865转1</span></div>
      </div>
    </el-dialog>
  
    <el-dialog
      :visible.sync="uploadVisible"
      top="20vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <span slot="title" style="font-weight: bold;font-size: 20px;color: red;">
        上传学时证明
      </span>
      <div class='self-upload'>
        <el-upload
          class="upload-demo"
          action="#"
          :show-file-list="false"
          :http-request="onUpload"
          accept="image/jpeg,image/png"
          :multiple="false">
          <div class="el-upload__tip">
            <div>
              <img :src="iFile" v-if="iFile" alt="">
              <span v-else>上传证明</span>
            </div>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleUpload">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="hintShow"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <span slot="title" style="font-weight: bold;font-size: 20px;color: red;">
        温馨提示
      </span>
      <div class="jyfs-dialog">
        <p style="text-align: center;">提交成功，请耐心等待！省局审核结果将于7个工作日内发送到您的手机短信，注意查收！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintShow = false">确定</el-button>
      </span>
    </el-dialog>
    
    <div
      class="wechat-pay-shell"
      @click.stop="clear_pay_timer()"
      v-if="show_wechat_pay"
    >
      <div class="wechat-content" @click.stop="">
        <img
          src="@/assets/colse-icon.png"
          alt=""
          class="colse-btn"
          @click.stop="
            show_wechat_pay = false,
            clear_pay_timer
          "
        />
        <div class="pay-tips">扫一扫付款 (元)</div>
        <div class="pay-price">￥{{ pay_money }}</div>
        <div class="pay-qrcode" @click.stop="show_wechat_pay = false">
          <div
            id="qrcode"
            ref="qrcode"
            style="width: 100%;height: 100%;"
          ></div>
        </div>
        <div class="pay-type">
          <img src="@/assets/weixin.png" alt="" class="wechat-pay-icon" />
          微信支付
        </div>
      </div>
    </div>
  
    <el-dialog
      title="温馨提示"
      width="600px"
      @close="onClose"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true"
      :show-close="false">
      <div class="wxts-dialog">
        <div>
          按省药监局要求：{{year}}年执业药师继续教育<span>专业科目60学时，计20学分</span>和<span>公需科目30学时，计10学分</span>必须完成。
        </div>
        <div>公需科目学习免费，每天不限学习时长！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "pharmacist-course",
  data() {
    return {
      course_id: 0, // 课程ID
      list: [], // 列表
      course_price: "0.00", // 价格
      directory_ids: [], // 选中课程id数组
      pay_money: "0.0", // 支付价格
      pay_timer: null, // 获取支付结果定时器
      file_period: 0, // 当前已选课程总学时
      alertNum: 1, // 控制不同时期弹窗展示
      sum_price: 0,
      pay_radio: 2,
      wayVisible: false,
      impVisible: true,
      bzVisible: false,
      auditVisible: false,
      auditVisible2: false,
      uploadVisible: false,
      iFile: '',
      hintShow: false,

      show_wechat_pay: false,
      dialogVisible: false,
      all_checked: false,
      show_check: false,
      year: '',
      cuurrent_year: '',
    };
  },
  props: ['leixing', 'total_period', 'need'],
  filters: {
    
  },
  watch: {
    
  },
  mounted() {
    // this.get_course_list()

    this.$nextTick(() => {
      this.init()
    })
  },
  beforeDestroy() {
    document.getElementById('app').onscroll = ()=>{}
    window.clearInterval(this.pay_timer);
  },
  methods: {
    init () {
      let w = document.getElementsByClassName('pharmacist-course-shell')[0].clientWidth
      document.getElementsByClassName('bottom-handle-pay')[0].style.width = w + 'px'
      setTimeout(() => {
        // 设置宽度
        let w = document.getElementsByClassName('pharmacist-course-shell')[0].clientWidth
        document.getElementsByClassName('bottom-handle-pay')[0].style.width = w + 'px'
        // 获取左边距
        let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft

        // 获取占位元素距离可视窗口顶部的距离
        // 滚动的距离 = 可视窗口顶部距离页面顶部的距离
        // 占位元素距离页面顶部的距离-滚动的距离= 占位元素距离可视窗口顶部的距离（pt）
        let top = document.getElementById("app").scrollTop
        let pt = document.getElementsByClassName('footer-place')[0].offsetTop
        pt = pt - top
        // 当pt大于(可视窗口高度-30)的距离时使元素悬浮
        if (pt > document.documentElement.clientHeight-50) {
          document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'fixed'
          document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '30px'
          document.getElementsByClassName('bottom-handle-pay')[0].style.left = left+'px'
          document.getElementsByClassName('bottom-handle-pay')[0].style.margin = '0'
        }
        document.getElementById('app').onscroll = () => {
          let top = document.getElementById("app").scrollTop
          let pt = document.getElementsByClassName('footer-place')[0].offsetTop
          pt = pt - top
          if (pt > document.documentElement.clientHeight-50) {
            let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft
            document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'fixed'
            document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '30px'
            document.getElementsByClassName('bottom-handle-pay')[0].style.left = left+'px'
          } else if (pt < document.documentElement.clientHeight-50) {
            // 当pt小于(可视窗口高度-30)的距离时使元素固定
            document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'relative'
            document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '0'
            document.getElementsByClassName('bottom-handle-pay')[0].style.left = '0'
          }    
        }
      }, 500)
    },
    // 控制不同时期弹窗展示
    getAlertNum () {
      this.API.post("Home/article_out-alert_num", {}).then(res => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.alertNum = res.data
      })
    },
    // 获取课程列表
    get_course_list(year, cuurrent_year) {
      this.year = year
      this.cuurrent_year = cuurrent_year
      if (Number(this.year) == this.cuurrent_year) {
        this.show_check = true
      }
      this.API.post("user/phar_in-get_phar_course", {
        
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.course_id = res.data.course_id;
        this.course_price = res.data.phar_course.course_price;
        let file_period = 0
        let list = res.data.phar_course.phar_course_info
        for (let i = 0; i < list.length; i++) {
          if (list[i].is_required) {
            list[i].is_select = true;
            file_period = file_period + list[i].file_period
          } else {
            list[i].is_select = false;
          }
          list[i].name = list[i].directory_name
          if (list[i].directory_name.indexOf('（上）') != -1) {
            list[i].name = list[i].directory_name.split("（上）")[0]
          }
          if (list[i].directory_name.indexOf('（下）') != -1) {
            list[i].name = list[i].directory_name.split("（下）")[0]
          }
        }
        this.file_period = Math.round(file_period * 100) / 100
        this.list = list;
        this.sum();
      });
    },
    handleCheck () {
      this.all_checked = !this.all_checked
      for (let i in this.list) {
        if (this.list[i].is_default == 1) {
          this.list[i].is_select = this.all_checked
        }
      }
      this.sum(this.all_checked);
    },
    // 选择课程
    cut_select(item, index) {
      if (item.is_required) {
        return this.API.SMessage("必选课程,不可取消");
      }
      this.list[index].is_select = !this.list[index].is_select;
      for (let v of this.list) {
        if (v.name === this.list[index].name) {
          v.is_select = this.list[index].is_select
        }
      }
      let list = this.list
      this.list = []
      this.$nextTick(() => {
        this.list = list
        this.sum(this.list[index].is_select);
      })
    },
    // 计算学时
    sum(type) {
      this.directory_ids = [];
      let file_period = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_select) {
          this.directory_ids.push(this.list[i].directory_id);
          file_period = file_period + this.list[i].file_period
        }
      }
      this.file_period = Math.round(file_period * 100) / 100
      this.sum_price = Math.floor(file_period) * 3
      let total_period = this.total_period || 0
      let price = 180 - Math.floor(total_period) * 3
      this.sum_price = this.sum_price > price ? price : this.sum_price 
      if (type && this.file_period >= 60) {
        this.$alert('您的选课已达到所需学时，请立即支付!', '提示', {
          confirmButtonText: '确认',
          closeOnPressEscape: false,
          center: true,
          roundButton: true,
          confirmButtonClass: 'alertBtn',
          customClass: 'alertFont'
        });
      }
    },
    handlePay () {
      if (this.file_period == 0) {
        this.$alert('请至少选择一门课程', '提示', {
          confirmButtonText: '确认',
          closeOnPressEscape: false,
          center: true,
          roundButton: true,
          confirmButtonClass: 'alertBtn',
          customClass: 'alertFont'
        });
        return
      }
      this.wayVisible = true
    },
    // 购买, 提交订单
    buy(pay_way) {
      // if (this.need == 60 && this.file_period < this.need && Number(this.year) == this.cuurrent_year) {
      //   if (this.alertNum == 1) {
      //     this.auditVisible = true
      //   } else {
      //     this.auditVisible2 = true
      //   }
      //   return
      // } else if (this.need != 60) {
      //   if (this.file_period < this.need && Number(this.year) == this.cuurrent_year) {
      //     this.$alert('您的选课未达到所需学时，请继续选课！', '提示', {
      //       confirmButtonText: '确认',
      //       closeOnPressEscape: false,
      //       center: true,
      //       roundButton: true,
      //       confirmButtonClass: 'alertBtn',
      //       customClass: 'alertFont'
      //     });
      //     return
      //   }
      // }
      this.API.post("user/phar_in-buy_phar_course", {
        course_id: this.course_id,
        directory_id: this.directory_ids.join(","),
        pay_way: pay_way,
        is_h5: 2,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        // if (res.errno == 0 && res.code == 1035) {
        //   this.API.SMessage("购买成功");
        //   this.$router.push("/personal");
        //   // return this.$router.push({ path: '/paymentOk?order_id=' + res.data.order_id })
        // }
        if (pay_way == 1) {
          this.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
          });
          if (!this.total_period) {
            this.dialogVisible = true
            return;
          }
          // this.$router.push('/personal')
          this.$router.push({ path: "/paymentOk?order_id=" + res.data.order_id });
        } else {
          this.show_wechat_pay = true;
          this.pay_money = res.data.pay_money;
          setTimeout(() => {
            this.make(res.data.pay_info.pay_info.code_url);
            let order_id = res.data.order_id;
            if (order_id) {
              this.pay_timer = setInterval(() => {
                this.get_order_detail(order_id);
              }, 1000);
            } else {
              this.API.SMessage("后台未返回order_id");
            }
          }, 100);
        }
      });
    },
    // 生成二维码
    make(linkUrl) {
      this.$refs.qrcode.innerHTML = ""; // 防止重复生成
      let qrcode = new QRCode("qrcode", {
        width: 160,
        height: 160,
        text: linkUrl,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // 定时获取获取支付结果,订单信息
    get_order_detail(order_id) {
      this.API.post("user/user_infos-order_detail", {
        order_id: order_id,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        if (res.data.order_info.order_status != "待付款") {
          window.clearInterval(this.pay_timer);
          this.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
          });
          if (!this.total_period) {
            this.dialogVisible = true
            return;
          }
          // this.$router.push('/personal')
          this.$router.push({ path: "/paymentOk?order_id=" + order_id });
        }
      });
    },
    // 清除定时器
    clear_pay_timer() {
      this.show_wechat_pay = false;
      window.clearInterval(this.pay_timer);
    },
    // 弹窗关闭
    onClose () {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.$router.push({ path: "/PublicList?year=" + this.year });
        }
      })
    },
    // 上传凭证
    onUpload (data) {
      var fileReader = new FileReader();
      fileReader.onload = e => {
        this.dealImage(e.target.result, 600, (base64) => {
          let imgSrc = base64;
          
          let fd = new FormData()
          fd.append('token', localStorage.getItem('token'))
          fd.append('file', imgSrc)
          this.API.post('user/user_infos-upload_img', fd).then((res) => {
            if (res.errno != 0) {
              return this.API.SMessage(res.message)
            }
            this.iFile = res.data.file_url
          })
        });
        // let file = e.target.result

        // var arr = file.split(',');
        // var mime = arr[0].match(/:(.*?);/)[1];
        // var bstr = atob(arr[1]);
        // var n = bstr.length;
        // var u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // file = new Blob([u8arr], { type: mime });
        // file.lastModifiedDate = new Date();
        // file.name = '设备信息';
        // this.dataForm.iFile = URL.createObjectURL(file);
        // this.onSubmit()
      };
      fileReader.readAsDataURL(data.file);
    },
    dealImage(base64, w, callback) {
      var newImage = new Image();
      var quality = 0.3; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function () {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          quality = 0.6;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        callback(base64);
      };
    },
    handleUpload () {
      this.uploadVisible = false
      this.hintShow = true
    }
  },
};
</script>

<style lang="less" scoped>
.loose-view {
  .all_checked {
    display: flex;
    justify-content: end;
    margin-bottom: 20px;
    > div {
      width: 120px;
      height: 45px;
      color: #fff;
      line-height: 45px;
      text-align: center;
      cursor: pointer;
      font-size: 20px;
      border: 1px solid #2aa9b5;
      background-color: #2aa9b5;
    }
    > .check {
      border: 1px solid #ff4050;
      background-color: #ff4050;
    }
  }
  .course-arr {
    display: flex;
    flex-wrap: wrap;
    .course-item {
      margin-bottom: 20px;
      display: flex;
      width: 30%;
      margin-right: 40px;
      > img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
      }
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        h3 {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          white-space: pre-wrap;
          word-break: break-all;
          margin-bottom: 10px;
        }
        > span {
          margin-bottom: 10px;
          color: #666666;
        }
        > div {
          width: 130px;
          height: 30px;
          line-height: 30px;
          border-radius: 15px;
          border: 1px solid #2aa9b5;
          text-align: center;
          color: #2198a3;
          cursor: pointer;
          &:hover {
            background-color: rgb(48, 236, 253);
            color: #2198a3;
          }
        }
        .btn {
          background-color: #2aa9b5;
          color: #ffffff;
        }
        .disabled {
          border: #aaa;
          background-color: #aaa;
          &:hover {
            background-color: #aaa;
            color: #fff;
          }
        }
      }
    }
  }
  .bottom-handle-pay {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100px;
    border-radius: 50px;
    padding: 0 20px;
    background: #eeeeee;
    border: 1px solid #2198a3;
  
    .bottom-tips {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-right: 20px;
      white-space: nowrap;
      .num {
        text-decoration: underline;
        display: inline-block;
        padding: 0 10px;
        color: red;
        white-space: nowrap;
      }
    }
        
    .total-price {
      white-space: nowrap;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-right: 20px;
    }
  
    .pay-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: red;
      border-radius: 10px;
      font-size: 26px;
      font-family: PingFang SC;
      padding: 10px 15px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }
  
    .price,
    .num {
      color: rgba(216, 37, 28, 1);
      font-size: 34px;
    }
  }

  .pay_way {
    padding: 0 10px;
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      cursor: pointer;
      border: 1px solid #ccc;
      padding: 10px 20px;
      border-radius: 5px;
      > img {
        width: 50px;
      }
      > span {
        flex: 1;
        margin: 0 10px;
      }
      &:last-child {
        margin-top: 30px;
      }
      > div {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ccc;
      }
      .checke {
        border: 7px solid #2aa9b5;
      }
    }
  }

  
  .wechat-pay-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  
    .wechat-content {
      position: relative;
      width: 710px;
      height: 592px;
      background-color: #fff;
      padding: 60px;
  
      .colse-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 24px;
        height: 24px;
      }
  
      .pay-tips {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }
  
      .pay-price {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #d8251c;
        text-align: center;
        margin-top: 10px;
      }
  
      .pay-qrcode {
        width: 252px;
        height: 252px;
        border: 1px solid #eee;
        margin: 20px auto;
      }
  
      .pay-type {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
  
        .wechat-pay-icon {
          width: 34px;
          height: 30px;
          margin-right: 10px;
        }
      }
    }
  }
}

/deep/ .el-dialog__title {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}

.wxts-dialog {
  span,
  > div {
    text-indent: 40px;
    font-size: 20px;
    line-height: 40px;
    color: #000000;
    span {
      color: red;
    }
  }
}

.hint-text {
  font-size: 16px;
  margin:0 auto 20px;
  text-indent: 33px;
  line-height: 30px;
}
.hint-zd {
  font-size: 16px;
  color: red;
  font-weight: bold;
}

.jsbz {
  &::-webkit-scrollbar{
    width:5px;
    height:5px;
    cursor: pointer;
    /**/
  }
  &::-webkit-scrollbar-track{
    background: rgb(239, 239, 239);
    cursor: pointer;
    border-radius:2px;
  }
  &::-webkit-scrollbar-thumb{
    background: #bfbfbf;
    border-radius:10px;
    cursor: pointer;
  }
  &::-webkit-scrollbar-thumb:hover{
    background: #999;
    cursor: pointer;
  }
  &::-webkit-scrollbar-corner{
    background: #999;
    cursor: pointer;
  }
}

.jyfs-dialog {
  > p {
    font-size: 22px;
    margin: 0 auto 20px;
    line-height: 30px;
    > span {
      color: red;
      font-weight: bold;
      font-size: 22px;
    }
  }
  > nav,
  > div {
    font-size: 20px;
    margin: 0 auto 20px;
    text-align: center;
    line-height: 30px;
    > img {
      width: 160px;
    }
    .hint-zd {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
  }
  > nav {
    font-size: 20px;
  }
  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    .el-button+.el-button {
      margin-left: 30px;
    }
  }
}
.self-upload {
  display: flex;
  margin: 0 auto;
  width: fit-content;
  .el-upload__tip {
    > div {
      width: 200px;
      height: 200px;
      background-color: #f0f0f0;
      border: 1px dashed #ccc;
      margin-bottom: 10px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 100%;
        height: 100%;
      }
      > span {
        color: #888;
        font-size: 20px;
      }
    }
  }
}

/deep/ .el-icon-close {
  font-size: 25px
}
.el-dropdown-menu {
  border: 1px solid #30ecfd;
  > li {
    border-bottom: 1px solid #ccc;
  }
}
</style>
